/**
 * Resize gtranslate select box to fit currently selected text
 */
export function initGTranslate($) {
    const $select = $(".gt_selector");

    $select.each(function (n, el) {
        el.addEventListener("change", (event) => {
            let tempSelect = document.createElement("select"),
                tempOption = document.createElement("option");

            tempOption.textContent = event.target.options[event.target.selectedIndex].text;
            tempSelect.style.cssText += `
				visibility: hidden;
				position: fixed;
				`;
            tempSelect.appendChild(tempOption);
            event.target.after(tempSelect);

            const tempSelectWidth = tempSelect.getBoundingClientRect().width;

            if (tempSelectWidth > 0) {
                event.target.style.width = `${tempSelectWidth}px`;
            }

			tempSelect.remove();
        });

        el.dispatchEvent(new Event("change"));
    });
}
